exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".calendar{font:10px sans-serif;height:100%;width:100%;float:left;margin-right:1em}.calendar .graph{position:relative;height:calc(100% - 130px);overflow-y:scroll;overflow-x:hidden}.calendar .legend{position:relative;margin-left:10px;padding-left:10px;box-sizing:content-box;left:0;right:0;height:70px}.calendar .legend h3{text-align:center;margin-bottom:0}.calendar .legend .block{display:inline-block;border:1px solid #ccc;width:20px;height:20px;vertical-align:middle}.legend .items{float:right}.legend .item{vertical-align:top;display:inline-block}.legend .item span:last-child{padding:0 8px}.calendar canvas,.calendar svg{position:absolute;left:0;top:0;margins:0;padding:0}.calendar .period{cursor:pointer}.foreground .tooltip{font-size:11px}.zoomed .x.axis,.zoomed .y.axis,.zoomed rect{display:none}.x.axis .month{text-transform:capitalize}.calendar-legend{position:absolute;top:0;right:40px;width:115px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./css/calendar.css
// module id = 96
// module chunks = 0